import { Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { NOTIFICATION_ID } from "../../constants/Notification";
import ProposalState from "../../constants/ProposalState";
import UserType from "../../constants/UserType";
import { countGigsByState } from "../../firebase/gig";
import { sendNotificationRequest } from "../../firebase/notification";
import {
  updateFirstTimeGigPopup,
  updateFirstTimeLoginPopup,
} from "../../firebase/popup";
import { RootState } from "../../redux/store";
import PopupComponent from "../PopupComponent";

const AddFirstGig = () => {
  const { user } = useSelector((state: RootState) => state.user);
  const [open, setOpen] = useState<boolean>(false);
  const handleClose = () => {
    setOpen(false);
  };

  const handlePopupOpen = async () => {
    if (!user.uid) {
      return;
    }
    if (user.userType && user.userType === UserType.Chef) {
      setOpen(false);
    }
    const noOfGigs = await countGigsByState(user.uid, ProposalState.NEW_GIG);
    if (noOfGigs === 1 && !user.displayFirstGigPopup) {
      setOpen(true);
      await updateFirstTimeGigPopup(user.uid);
      await sendNotificationRequest(user.uid, NOTIFICATION_ID.OB9L);
    }
  };
  useEffect(() => {
    handlePopupOpen();
  }, [user]);

  return (
    <PopupComponent
      button2Function={handleClose}
      notificationId={
        user.userType === UserType.Client
          ? NOTIFICATION_ID.PU6L
          : NOTIFICATION_ID.PU6H
      }
      user={user}
      open={open}
      handleClose={handleClose}
    />
  );
};

export default AddFirstGig;
